import { FaFacebook, FaGithub, FaLinkedin, FaTwitter, FaWhatsapp, FaYoutube } from "react-icons/fa"
export const HeaderIconData = [
    {
        icon: <FaFacebook />,
        link: "https://www.facebook.com/asrmiltonkhan"
    },
    {
        icon: <FaYoutube />,
        link: "https://www.youtube.com/@srmiltonkhan"
    },
    {
        icon: <FaGithub />,
        link: "https://github.com/srmiltonhossain"
    },
    {
        icon: <FaWhatsapp />,
        link: "https://wa.me/+8801516034438"
    },
    {
        icon: <FaTwitter />,
        link: "https://twitter.com/SRMILTONKHAN"
    },
    {
        icon: <FaLinkedin />,
        link: "https://www.linkedin.com/in/srmiltonhossain/"
    },
]